import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { formatImageWebpAuto } from '@ifeng-fe/public_method';

const PicText = ({ content }) => {
    const thumbnails = content?.thumbnails?.image?.[0]?.url;

    return (
        <a href={content.url} target="_blank" className={styles.picText}>
            {thumbnails && <img className={styles.pic} src={formatImageWebpAuto(thumbnails, 144, 96)} />}
            <div className={styles.text}>
                <div className={styles.title}>{content.title}</div>
                {content.summary && <div className={styles.bref}>{content.summary}</div>}
            </div>
        </a>
    );
};

PicText.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(PicText);
